module.exports = __webpack_public_path__ + "static/cly-d9b29c6fbe1a56f6403c4d382e3c9a4f.jpeg";